import { render, staticRenderFns } from "./ConfigurationList.vue?vue&type=template&id=2028ca78"
import script from "./ConfigurationList.vue?vue&type=script&lang=js"
export * from "./ConfigurationList.vue?vue&type=script&lang=js"
import style0 from "./ConfigurationList.vue?vue&type=style&index=0&id=2028ca78&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports